import { Form, FormHelpersProviderReturn } from '../../../ana-toolbox'

export const resetFields = (fields: Array<keyof Form>, helpers: FormHelpersProviderReturn) => {
  const newValues = Object.fromEntries(fields.map((field) => [field, undefined]))
  const newTouched = Object.fromEntries(fields.map((field) => [field, false]))

  helpers.setValues((previous) => ({
    ...previous,
    ...newValues,
  }))

  helpers.setTouched(newTouched)
}
